import { ChevronDownIcon } from "@heroicons/react/solid"
import { SVGProps } from "react"

export default (props: SVGProps<SVGSVGElement>) => {
    return (
        <ChevronDownIcon {...props}/>
    )
}